<template>
  <v-container fluid class="pa-0">
    <div class="main-container">
      <v-card class="login-card text-center" elevation="5">
        <img class="logo" src="@/assets/logo.png" alt="logo" />
        <h3>INICIAR SESIÓN</h3>
        <v-form v-model="valid" @submit.prevent="login()">
          <v-row justify="center">
            <v-col cols="12">
              <v-text-field
                v-model="email"
                :rules="[required, emailRule]"
                label="Correo"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12">
              <v-text-field
                v-model="password"
                :rules="[required]"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                label="Contraseña"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                class="mr-4"
                type="submit"
                :loading="processing"
                :disabled="!valid"
              >
                {{ processing == false ? "Entrar" : "Iniciando sesión..." }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn text color="error">He olvidado mi contraseña</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </div>
    <Footer></Footer>
  </v-container>
</template>

<script>
import { login, httpGet } from "../services/apiService";
import { required, email as emailRule } from "../helpers/formHelpers";
import { sha512 } from "js-sha512";
import Footer from "../components/Footer.vue";

export default {
  name: "Auth",
  components: {
    Footer,
  },
  data() {
    return {
      email: null,
      password: null,
      showPassword: false,
      processing: false,
      valid: false,
      required,
      emailRule,
    };
  },
  methods: {
    async login() {
      this.processing = true;

      const body = {
        identifier: this.email,
        password: sha512(this.password),
      };

      const { data } = await login(body).catch((err) => {
        this.processing = false;
        if (err.code == "ERR_BAD_REQUEST") {
          this.$toasted.show("Usuario o contraseña inválido", {
            type: "error",
          });
          return;
        }
        this.$toasted.show("No fue posible comunicarse con el servidor.", {
          type: "error",
        });
        throw err;
      });

      this.processing = false;
      sessionStorage.setItem("token", data?.jwt);
      const { data: userData } = await httpGet("/users/me");
      this.$store.dispatch("setUserData", {
        ...data?.user,
        role: userData?.role?.type,
      });
    },
  },
};
</script>

<style lang="scss">
.main-container {
  background-image: url(../assets/authbg.png);
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  min-height: 95vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-card {
  width: 100%;
  height: 100%;
  max-width: 350px !important;
  min-height: 400px;
  max-height: 600px !important;
  padding: 10px;
}

.logo {
  text-align: center;
  margin-top: 25px;
  max-width: 325px;
}

h3 {
  margin-top: 15px;
}
</style>